export default __webpack_public_path__ + "static/media/banner_for_new_account.b6d2c8b1.png";